module.exports = __webpack_public_path__ + "img/CV.Drainage_SUDS.Below_Ground_attenuation.Concrete_tank_below_ground_attenuation.11b13d07.png";